<script setup>
import { ref } from 'vue'
import { PencilAltIcon, CheckIcon } from "@heroicons/vue/outline"

const props = defineProps({
	modelValue: {
		type: String,
		default: '',
	},
})

const emit = defineEmits(['update:modelValue'])

const editing = ref(false)
const notes = ref(props.modelValue)

const save = () => {
	emit('update:modelValue', notes.value)
	editing.value = false
}
</script>

<template>
	<SectionCard title="Notes">
		<div class="my-3">
			<div
				v-html="notes"
				v-if="!editing"
				class="whitespace-pre-wrap"
			></div>
			<div
				v-if="!notes && !editing"
				class="py-8 italic text-sm text-center text-gray-500"
			>
				Click "Edit Notes" to add some notes
			</div>
			<textarea
				v-model="notes"
				v-if="editing"
				class="w-full border border-gray-300 rounded-md p-2"
				rows="5"
				data-testid="edit-notes-field"
			></textarea>
		</div>

		<template #footer>
			<Button 
				v-if="!editing"
				@click="editing = true" 
				color="blue"
				data-testid="notes-edit-button"
			>
				<PencilAltIcon class="w-4 h-4 mr-2 inline" /> Edit Notes
			</Button>
			<Button 
				v-if="editing"
				@click="save" 
				color="blue"
				data-testid="notes-save-button"
			>
				<CheckIcon class="w-4 h-4 mr-2 inline" /> Save
			</Button>
		</template>
	</SectionCard>
</template>